
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as PinIconComponent } from "./pin-icon.svg";

export const PinIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <PinIconComponent {...props} />;
};
